<template>
  <pt-lab-test-platform-list class="pt-lab-test-platform-list__page"></pt-lab-test-platform-list>
</template>

<script>
import PtLabTestPlatformList from 'cps/gene-product/pt-lab-test-platform-list/withData'
export default {
  name: 'pt-lab-test-platform-list__view',
  components: {
    'pt-lab-test-platform-list': PtLabTestPlatformList
  }
}
</script>
